import { Component, Input } from '@angular/core';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'mom-survey-header',
  templateUrl: './survey-header.component.html',
  styleUrls: ['./survey-header.component.scss']
})
export class SurveyHeaderComponent {
  @Input() count: number;
  @Input() description: string;
  @Input() index: number;
  @Input() progress = 0;

  faInfoCircle = faInfoCircle;
}
